import { defaultCodes } from "../utils/defaultCodes";

export const functionData = [
  {
    name: "Hello World Web",
    id: "webserver",
    entryPoint: "0.0.0.0",
    uri: "/web-server",
    scheme: "http",
    language: "Web Server",
    hostname: "abc.abc.com",
    code: defaultCodes("Go"),
  },
  {
    name: "Hello World",
    id: "as",
    entryPoint: "0.0.0.0",
    uri: "/check",
    scheme: "http",
    language: "Go",
    hostname: "abc.abc.com",
    code: defaultCodes("Go"),
  },
  {
    name: "Hello World 1",
    id: "asd",
    entryPoint: "0.0.0.1",
    uri: "/checkk",
    scheme: "http",
    language: "Python",
    hostname: "abc.xyz.com",
    code: defaultCodes("Python"),
  },
  {
    name: "Hello World 2",
    id: "assd",
    entryPoint: "0.0.0.0",
    uri: "/check",
    scheme: "http",
    language: "Go",
    hostname: "abc.abc.com",
    code: defaultCodes("Go"),
  },
  {
    name: "Hello World 3",
    id: "asdf",
    entryPoint: "0.0.0.1",
    uri: "/checkk",
    scheme: "http",
    language: "Python",
    hostname: "abc.xyz.com",
    code: defaultCodes("Python"),
  },
  {
    name: "Hello World 4",
    id: "qwer",
    entryPoint: "0.0.0.0",
    uri: "/check",
    scheme: "http",
    language: "Go",
    hostname: "abc.abc.com",
    code: defaultCodes("Go"),
  },
  {
    name: "Hello World 5",
    id: "sd",
    entryPoint: "0.0.0.1",
    uri: "/checkk",
    scheme: "http",
    language: "Python",
    hostname: "abc.xyz.com",
    code: defaultCodes("Python"),
  },
  {
    name: "Hello World 6",
    id: "kh",
    entryPoint: "0.0.0.0",
    uri: "/check",
    scheme: "http",
    language: "Go",
    hostname: "abc.abc.com",
    code: defaultCodes("Go"),
  },
  {
    name: "Hello World 7",
    id: "12e",
    entryPoint: "0.0.0.1",
    uri: "/checkk",
    scheme: "http",
    language: "Python",
    hostname: "abc.xyz.com",
    code: defaultCodes("Python"),
  },
  {
    name: "Hello World 8",
    id: "34",
    entryPoint: "0.0.0.0",
    uri: "/check",
    scheme: "http",
    language: "Go",
    hostname: "abc.abc.com",
    code: defaultCodes("Go"),
  },
  {
    name: "Hello World 9",
    id: "ooe",
    entryPoint: "0.0.0.1",
    uri: "/checkk",
    scheme: "http",
    language: "Python",
    hostname: "abc.xyz.com",
    code: defaultCodes("Python"),
  },
  {
    name: "Hello World 10",
    id: "ooyui",
    entryPoint: "0.0.0.1",
    uri: "/checkk",
    scheme: "http",
    language: "Python",
    hostname: "abc.xyz.com",
    code: defaultCodes("Python"),
  },
];

export const certificateData = [
  {
    id: 1,
    certificate: "abc.abc.com",
    key: "RSA (2048 bits)",
    issuer: "Let's Encrypt",
    validity: "Sep 25 03:53:50 2023 GMT - Dec 24 03:53:50 2023 GMT",
  },
];
